import React, { Component } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

export class AdditionalInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            giftCardNum: props.item.giftCardNum,
            serialNum: props.item.serialNum
        }
        this.changeGiftCard = this.changeGiftCard.bind(this);
        this.changeSerialNum = this.changeSerialNum.bind(this);
    }

    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if (!this.props.item.editSerialNum && this.props.item.serialNum !== this.state.serialNum) {
            this.setState({
                serialNum: this.props.item.serialNum
            });
        }
        if (!this.props.item.editGiftCard && this.props.item.giftCardNum !== this.state.giftCardNum) {
            this.setState({
                giftCardNum: this.props.item.giftCardNum
            });
        }
    }

    changeGiftCard(newValue) {
        this.setState({
            giftCardNum: newValue.toUpperCase()
        });
    }

    changeSerialNum(newValue) {
        this.setState({
            serialNum: newValue.toUpperCase()
        });
    }

    render() {
        return (
            <div className="additionalInfo">
                {
                    this.props.item.isGiftCard
                    &&
                    <form onSubmit={(e) => this.props.updateGiftCardNum(e, this.props.item.lineId)}>
                        {(this.props.item.giftCardNum && !this.props.item.editGiftCard) && <FontAwesomeIcon className="addInfoCheck" icon={faCheckCircle} />}
                        <label htmlFor="giftCard">{this.props.additionalInfoOptions['giftCard'].promptText}: </label>
                        <input
                            required
                            pattern={this.props.additionalInfoOptions['giftCard'].regex}
                            autoComplete="off"
                            value={this.state.giftCardNum}
                            type="text"
                            id={"giftCard" + this.props.item.lineId}
                            name="giftCard"
                            onChange={(event) => this.changeGiftCard(event.target.value)}
                            disabled={!this.props.item.editGiftCard}
                            //onBlur={(event) => this.changeGiftCard(event.target.value)}
                        />
                        {!this.props.item.editGiftCard && <FontAwesomeIcon className="addInfoCheck" icon={faEdit} onClick={() => this.props.editInputField("gc",this.props.item.lineId)}/>}
                    </form>
                }
                {
                    (this.props.item.needsSerialNum)
                    &&
                    <form onSubmit={(e) => this.props.updateSerialNum(e, this.props.item.lineId)} >
                        {(this.props.item.serialNum && !this.props.item.editSerialNum) && <FontAwesomeIcon className="addInfoCheck" icon={faCheckCircle} />}
                        <label htmlFor="serialNum">{this.props.additionalInfoOptions['serialNum'].promptText}: </label>
                        <input
                            required
                            pattern={this.props.additionalInfoOptions['serialNum'].regex}
                            autoComplete="off"
                            value={this.state.serialNum}
                            type="text"
                            id={"serialNum-" + this.props.item.lineId}
                            name="serialNum"
                            onChange={(event) => this.changeSerialNum(event.target.value)}
                            disabled={!this.props.item.editSerialNum}
                            //onBlur={(event) => this.changeSerialNum(event.target.value)}
                        />
                        {!this.props.item.editSerialNum && <FontAwesomeIcon className="addInfoCheck" icon={faEdit} onClick={() => this.props.editInputField("sn",this.props.item.lineId)}/>}
                    </form>
                }
            </div>
        );
    }
}
